import { Breadcrumbs } from "@/components"
import { Marketing } from "@/components/Marketing"
import Layout from "@/layout"
import { NotFoundProps, getNotFoundProps } from "@/lib/notFound"
import { fetchMarket } from "@/lib/prismicio/market"
import { MarketingContentDocument } from "@/lib/prismicio/types.generated"
import { buildPageProps } from "@/lib/ssg/slug"
import { FeaturedProductsContext, breadcrumbArray } from "@jog/react-components"
import { RedisMarketItem, buildFeaturedProducts, fetchS3ContentPage, retry } from "@jog/shared"
import { FeaturedProduct, MarketPage, StaticPropsCommon } from "@jog/types"
import { GetStaticPropsContext } from "next"
import { GetStaticPropsResult } from "next/types"

export const buildMarketPage = async (
    redisItem: RedisMarketItem,
    context: GetStaticPropsContext
): Promise<
    GetStaticPropsResult<(StaticPropsCommon & { page: MarketPage<MarketingContentDocument> }) | NotFoundProps>
> => {
    const { deps, ...others } = redisItem
    if (!redisItem.deps) {
        return getNotFoundProps(context)
    }
    const prismic = await retry(() =>
        context.preview && context.previewData
            ? fetchMarket(deps.uid, context.previewData)
            : fetchS3ContentPage<MarketingContentDocument>("marketing_content", deps.uid)
    )
    const featuredProducts = await buildFeaturedProducts(prismic, others.locale)
    return buildPageProps(context, { prismic, ...others }, featuredProducts)
}

export const MarketingPageContent = ({
    page,
    featuredProducts,
}: {
    featuredProducts: FeaturedProduct[]
    page: MarketPage<MarketingContentDocument>
}) => {
    return (
        <Layout>
            {page.prismic.data.show_breadcrumb ? <Breadcrumbs list={breadcrumbArray(page.path.split("/"))} /> : <></>}
            <FeaturedProductsContext.Provider value={{ products: featuredProducts }}>
                <Marketing prismic={page.prismic.data} />
            </FeaturedProductsContext.Provider>
        </Layout>
    )
}
